import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Zircon from "../../picture/ZIRCON-LOGO-removebg-preview.png";
// import Amethyst from "../../picture/LOGO_Dronesign.png";
import Amethyst from "../../picture/AMETHYST-LOGO-removebg-preview.png";
import S_TREC from "../../picture/S-TREC Final-02.png";
import Jasper from "../../picture/jasper-01.png";
import Card from "react-bootstrap/Card";
import spacebackground from "../../picture/b.jpg";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
const Welcome = () => {
  let Navigate = useNavigate();
  useEffect(() => {
    Navigate("/welcome");
  }, []);
  return (
    <div style={{ backgroundImage: `url(${spacebackground})` ,height:"100vh"}}>
      <div>
        <Card
          style={{
            width: "40%",
            border: "none",
            boxShadow: "none",
            background: "none",
            margin: "auto",
          }}
        >
          <Card.Img variant="top" src={S_TREC} />
        </Card>
      </div>

      <div style={{ display: "flex" }}>
        <Row style={{ width:"100%" }}>
          <Col xs={6} md={4}>
            <Card
              style={{
                //width: "32%",
                backgroundColor:"white",
                borderRadius:"50%",
                border: "none",
                boxShadow: "none",
                //background: "none",
                margin: "auto",
                marginBottom: "39px",
                marginTop: "50px",
                cursor:"pointer"
              }}
              onClick={() => {
                Navigate("/login");
                window.location.reload();
              }}
            >
              <Card.Img variant="top" src={Amethyst} style={{
                marginTop:"10px",
                marginBottom: "5px",
              }}/>
            </Card>
          </Col>
          <Col xs={6} md={4}>
            <Card
              style={{
                //width: "32%",
                backgroundColor:"white",
                borderRadius:"50%",
                border: "none",
                boxShadow: "none",
                //background: "none",
                cursor:"pointer"
              }}
              onClick={() => window.open("http://amethyst.gistda.or.th:8080/")}
            >
              <Card.Img
                variant="top"
                src={Zircon}
                style={{
                  width: "70%",
                  height: "55%",
                  objectFit: "cover",
                  margin: "auto",
                  border: "none",
                  marginBottom: "39px",
                  marginTop: "25px",
                }}
              />
            </Card>
          </Col>
          <Col xs={6} md={4} >
            <Card
              style={{
                //width: "32%",
                backgroundColor:"white",
                borderRadius:"50%",
                border: "none",
                boxShadow: "none",
                //background: "none",
                cursor:"pointer",
                
              }}
              onClick={() => window.open("http://amethyst.gistda.or.th:8080/")}
            >
              <Card.Img
                variant="top"
                src={Jasper}
                style={{
                  width: "60%",
                  height: "55%",
                  objectFit: "cover",
                  margin: "auto",
                  marginBottom: "16px",
                  marginTop: "8px",
                  border: "none",
                }}
              />
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Welcome;
